/**
 * SVG injector. Supports each modern browser and IE9+.
 * @module
 */
(function (root) {
    /**
     *
     * @param {HTMLElement} region
     * @returns {SVGInjector}
     * @constructor
     */
    function SVGInjector(region) {
        /**
         *
         * @param {HTMLElement} region
         * @private
         */
        this._region = region;

        return this;
    }

    /**
     *
     * @param {string} SVGPath
     * @param {function} callback
     * @param {Object} context
     * @private
     */
    SVGInjector.prototype._fetchSVGFileContent = function _fetchSVGFileContent(SVGPath, callback, context) {
        var request = new XMLHttpRequest();

        request.open('GET', SVGPath, true);

        request.onreadystatechange = function () {
            if ((request.readyState === 4) && (request.status === 200)) {
                callback.call(context, request);
            }
        };

        request.send();
    };

    /**
     *
     * @param {Object} testObject
     * @static
     * @returns {boolean}
     */
    SVGInjector.isEmptyObject = function isEmptyObject(testObject) {
        return (Object.getOwnPropertyNames(testObject).length === 0);
    };

    /**
     *
     * @param {string} XMLText
     * @returns {Element}
     * @private
     */
    SVGInjector.prototype._createVirtualDOMElement = function _createVirtualDOMElement(XMLText) {
        var virtualDOMElement = document.createElement('div');
        virtualDOMElement.innerHTML = XMLText;
        return virtualDOMElement;
    };

    /**
     *
     * @param {HTMLElement} inheritedElement
     * @param {HTMLElement} baseElement
     * @returns {HTMLElement}
     * @private
     */
    SVGInjector.prototype._applyAttributes = function _applyAttributes(inheritedElement, baseElement) {
        var SVGAttributes = baseElement.attributes;

        for (var i = 0, len = SVGAttributes.length; (i < len); i += 1) {
            if (SVGInjector.FORBIDDEN_SVG_ATTRIBUTES.indexOf(SVGAttributes[i].name) < 0) {
                //NOTE: IE9 Only supports console functions when developer tools are open,
                // otherwise the console object is undefined and any calls will throw errors.
                if (inheritedElement.hasAttribute(SVGAttributes[i].name) && console) {
                    console.warn('Inherited element has `%s` attribute and it will be replaced.', SVGAttributes[i].name);
                }
                inheritedElement.setAttribute(SVGAttributes[i].name, SVGAttributes[i].value);
            }
        }

        //NOTE: Apply event handlers.
        if (baseElement.getEventListeners) {
            var eventListeners = baseElement.getEventListeners();

            eventListeners.forEach(function (eventListener) {
                inheritedElement['on' + eventListener.type] = eventListener.listener;
            });
        }

        return inheritedElement;
    };

    /**
     *
     */
    SVGInjector.prototype.launch = function launch() {
        var elements = this._region.querySelectorAll(SVGInjector.FETCH_ELEMENTS);

        // Iterate via each elements contains *.svg in passed region property.
        [].forEach.call(elements, function parseElements(element) {

            this._fetchSVGFileContent(element.getAttribute('src'), function parseResponse(request) {
                var SVGContent = request.responseXML;

                if (!SVGContent) {
                    return;
                }

                if (SVGInjector.isEmptyObject(SVGContent)) {
                    //NOTE: IE9 returns empty object in responseXML. For repair it, we must create virtual DOM element,
                    // inject to it responseText and returns content.
                    SVGContent = this._createVirtualDOMElement(request.responseText);
                }

                if (element && element.parentNode) {
                    // Replace image element by svg content.
                    element.parentNode.replaceChild(
                        this._applyAttributes(SVGContent.getElementsByTagName('svg')[0], element),
                        element
                    );
                }
            }, this);
        }, this);
    };

    /**
     *
     * @type {string}
     */
    SVGInjector.FETCH_ELEMENTS = '[src$=".svg"]';

    /**
     *
     * @type {string[]}
     */
    SVGInjector.FORBIDDEN_SVG_ATTRIBUTES = [ 'src' ];


    if (typeof module !== 'undefined' && module.exports) {
        module.exports = SVGInjector;
    } else if (typeof define === 'function' && define.amd) {
        define(function () {
            return SVGInjector;
        });
    } else {
        root.SVGInjector = SVGInjector;
    }
})(this);
